import { dataPathSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPathSolid = /*#__PURE__*/createIcon(dataPathSolid)
export default IconPathSolid
